module.exports = __webpack_public_path__ + "static/img/bg_coupon_tag_out.1bdcccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_tag_out.png
// module id = Gh9N
// module chunks = 0